import axios from "axios";

import { CartContext, CartItem, CartResult } from "custom-types/Cart";
import { CountryCode } from "custom-types/Finder";
import logError from "utils/logError";

import {
  reservationsApi,
  ReservationsApiErrorsResponse,
} from "../services/reservations";

export const patchCartItems = async ({
  calculateTax = false,
  cartContext = null,
  cartItem,
  sessionId,
  domainCountryCode,
}: {
  calculateTax?: boolean;
  cartContext?: CartContext | null;
  cartItem: CartItem;
  sessionId: string;
  domainCountryCode: CountryCode;
}) => {
  try {
    const { data } = await reservationsApi({
      domainCountryCode,
    }).patch<CartResult>(
      `/cart_items/${cartItem.id}?calculate_tax=${calculateTax}`,
      {
        cartContext: cartContext,
        cartItem: {
          quantity: cartItem.quantity,
        },
      },
      {
        headers: {
          "X-Leafly-Id": sessionId,
        },
      }
    );

    if (data?.errors) {
      throw data.errors;
    }

    return data?.data;
  } catch (e) {
    const errorData =
      axios.isAxiosError(e) &&
      (e.response?.data as ReservationsApiErrorsResponse)?.errors;

    if (errorData) {
      logError(errorData[0].detail, {
        functionName: "patchCartItems",
        service: "reservations",
      });

      throw errorData[0].detail;
    } else if (Array.isArray(e)) {
      logError(e[0].detail, {
        functionName: "patchCartItems",
        service: "reservations",
      });

      throw e[0].detail;
    } else {
      logError(e.message || "reservationUnknownError", {
        functionName: "patchCartItems",
        service: "reservations",
        statusCode: e.code || "UNKNOWN",
      });

      throw e;
    }
  }
};
